import { useEffect, useRef, useState } from 'react';
import { API_ENDPOINT } from '../../lib/api';
import { fetch } from '../fetch';
import { z } from 'zod';
import { toast } from 'react-toastify';

export const UsageResponseSchema = z.object({
    usage: z.number(),
    limit: z.number(),
    userId: z.string()
});

export type UsageResponse = z.infer<typeof UsageResponseSchema>;

export async function getUsage() {
    const res = await fetch('/tinker-boxes/usage/live', {
        method: 'GET',
        headers: {
            Accept: 'text/event-stream'
        }
    });
    return res.json();
}

export function useUsageQuery() {
    const [data, setData] = useState<UsageResponse | null>(null);
    useEffect(() => {
        (async () => {
            const source = new EventSource(`${API_ENDPOINT}/tinker-boxes/usage/live`, {
                withCredentials: true
            });
            source.onmessage = (event) => {
                setData(UsageResponseSchema.parse(JSON.parse(event.data)));
            };
            return () => {
                source.close();
            };
        })();
    }, [setData]);

    return { data };
}

export function useUsage() {
    const usageQuery = useUsageQuery();
    const showedToast = useRef(false);

    useEffect(() => {
        if (!usageQuery.data) {
            return;
        }

        if (usageQuery.data.usage > usageQuery.data.limit && !showedToast.current) {
            showedToast.current = true;
            toast('You have exceeded your usage limit');
        }
    }, [usageQuery]);
}
